import { useContext, useMemo } from "react";
import { ActionContext } from "views/logic/ActionContext";
import useCurrentQuery from "views/logic/queries/useCurrentQuery";
import { filtersToStreamSet } from "views/logic/queries/Query";
const useCurrentStream = () => {
  var _a;
  const { widget, message } = useContext(ActionContext);
  const currentQuery = useCurrentQuery();
  return useMemo(
    () => {
      var _a2, _b, _c, _d;
      return (_d = (_c = (_b = (_a2 = message == null ? void 0 : message.fields) == null ? void 0 : _a2.streams) != null ? _b : widget == null ? void 0 : widget.streams) != null ? _c : filtersToStreamSet(currentQuery.filter).toJS()) != null ? _d : [];
    },
    [(_a = message == null ? void 0 : message.fields) == null ? void 0 : _a.streams, currentQuery.filter, widget == null ? void 0 : widget.streams]
  );
};
export default useCurrentStream;
